import React from 'react';
import { useTheme, useMediaQuery, PeekButton } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../pannellum-viewer/PannellumProvider.js';
import { CaretLeft } from '@piiqtechnologies/svg-icons';

const BackButton = ({}) => {
    const { BackButtonProps } = usePannellumViewer();
    const theme = useTheme();
    const mobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const desktopView = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    if (!BackButtonProps || !BackButtonProps.onClick) {
        return null;
    }
    return (React.createElement(PeekButton, { color: "secondary", onClick: BackButtonProps.onClick, variant: "contained", "area-label": BackButtonProps.label, sx: Object.assign(Object.assign({ minHeight: { xs: 26, md: 28, lg: 35 }, minWidth: { xs: 26, md: 53, lg: 66 }, height: { xs: 26, md: 28, lg: 35 } }, ((desktopView && theme.typography.h4) || theme.typography.body1)), { fontWeight: theme.typography.fontWeightBold }) },
        React.createElement(CaretLeft, { height: 12, width: 12 }),
        (!mobileView && (BackButtonProps.label || "Back")) || ""));
};

export { BackButton as default };
